module.exports = __webpack_public_path__ + "img/logo-inline-dark.41275322.svg";